import { NiceNavigationItem } from "@recursyve/nice-ui-kit.v2";

export const supplierNavigation: NiceNavigationItem[] = [
    {
        id: "purchase-order",
        title: "navigation.purchase_order",
        type: "basic",
        iconType: "svg",
        icon: "streamline-regular:shopping-cart",
        link: "/dashboard/purchase-order"
    }
];
